export class Sport {
  id: number | null = null;
  guid: string | null = null;
  name: string | null = null;

  supplier: any = [];
}
